import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

// The footer badges on every page. `width` and `height` are each file's own
// size (an SVG's viewBox); custom.scss draws the badge at the full width of
// its cell, up to `maxWidth`. The alt text matches the homepage's badge row:
// the Michigan Saves and Home Builders Association badges used to be labelled
// as two other organisations.
const defaults = [
  {
    style: { maxWidth: '55px' },
    src: 'CHAMBERS-OF-COMMERCE-160.webp',
    alt: 'Battle Creek Area Chamber accredited',
    width: 86,
    height: 160,
  },
  {
    style: { maxWidth: '110px' },
    src: 'epa-min.svg',
    alt: 'EPA Lead-Safe certified firm',
    width: 300,
    height: 202,
  },
  {
    style: { maxWidth: '90px' },
    src: 'MS-AuthorizedContractor-Badge-184.webp',
    alt: 'Michigan Saves authorized contractor',
    width: 184,
    height: 184,
  },
  {
    style: { maxWidth: '90px' },
    src: 'hba-michigan-min.svg',
    alt: 'Home Builders Association of Michigan',
    width: 438,
    height: 396,
  },
  { style: { maxWidth: '140px' }, src: 'bbb.svg', alt: 'BBB accredited business', width: 560, height: 400 },
]

const windows = [
  { style: { minWidth: '150px' }, src: 'jameshardie.svg', alt: 'James Hardie' },
  { src: 'amerimax.svg', alt: 'Amerimax' },
  { src: 'plygem.svg', alt: 'Plygem' },
  { src: 'alside.svg', alt: 'Alside' },
  { src: 'lp.svg', alt: 'LP', style: { padding: '0 20px' } },
  { src: 'mezzo.svg', alt: 'Mezzo' },
  { src: 'milgard.svg', alt: 'Milgard' },
  { src: 'trex.svg', alt: 'Trex', style: { padding: '0 25px' } },
]

const bathroomremodeling = [
  { src: 'fieldstone.svg', alt: 'Fieldstone' },
  { src: 'kohler.svg', alt: 'Kohler', style: { padding: '0px 8px' } },
  { src: 'toto.svg', alt: 'Toto', style: { padding: '0px 10px' } },
  { src: 'moen.svg', alt: 'Moen', style: { padding: '0px 12px' } },
  { src: 'armstrong.svg', alt: 'Armstrong' },
  { src: 'silestone.svg', alt: 'Silestone', style: { padding: '0 20px' } },
  { src: 'cambria.svg', alt: 'Cambria' },
  { src: 'piedrafina.svg', alt: 'Piedrafina' },
]

const remodeling = [
  { src: 'fieldstone.svg', alt: 'Fieldstone' },
  { src: 'waypoint.svg', alt: 'Waypoint' },
  { src: 'mbci.svg', alt: 'MBCI' },
  { src: 'silestone.svg', alt: 'Silestone', style: { padding: '0 20px' } },
  { src: 'ceasarstone.svg', alt: 'Caesarstone', style: { padding: '12px' } },
  { src: 'cambria.svg', alt: 'Cambria' },
]

const kitchencabinets = [
  { src: 'fieldstone.svg', alt: 'Fieldstone' },
  { src: 'waypoint.svg', alt: 'Waypoint' },
  { src: 'midcontent.svg', alt: 'Midcontent' },
  { src: 'woodmark.svg', alt: 'Woodmark' },
  { src: 'mbci.svg', alt: 'MBCI' },
]

const kitchenremodeling = [
  { src: 'fieldstone.svg', alt: 'Fieldstone' },
  { src: 'waypoint.svg', alt: 'Waypoint' },
  { src: 'mbci.svg', alt: 'MBCI' },
  { src: 'ceasarstone.svg', alt: 'Caesarstone', style: { padding: '12px' } },
  { src: 'silestone.svg', alt: 'Silestone', style: { padding: '0 20px' } },
  { src: 'cambria.svg', alt: 'Cambria' },
]

const siding = [
  { style: { minWidth: '150px' }, src: 'jameshardie.svg', alt: 'James Hardie' },
  { src: 'amerimax.svg', alt: 'Amerimax' },
  { src: 'plygem.svg', alt: 'Plygem' },
  { src: 'alside.svg', alt: 'Alside', style: { padding: '12px' } },
  { src: 'lp.svg', alt: 'LP', style: { padding: '0 20px' } },
  { src: 'mezzo.svg', alt: 'Mezzo' },
  { src: 'milgard.svg', alt: 'Milgard' },
  { src: 'certainteed.svg', alt: 'Certainteed' },
]

const getShowCase = (footerLogoShowcase) => {
  switch (footerLogoShowcase) { 
    default:
      return { items: defaults }
  }
}

const Logos = ({ productLogos }) =>
  productLogos.map(({ style, src, alt, width, height }, i) => (
    <div className="p-logo-item p-2" key={i}>
      <img
        src={`/assets/logos/products/${src}`}
        loading="lazy"
        style={{ ...style }}
        alt={alt}
        width={width}
        height={height}
        draggable="false"
      />
    </div>
  ))

const ProductLogoShowcase = (footerLogoShowcase) => {
  const { className, items } = getShowCase(
    footerLogoShowcase.footerLogoShowcase
  )
 
  return (
 <div className='bg-gradient-to-b from-transparent to-white'>
  <div className=' grid border-b py-4 border-gray-200 grid-cols-3 sm:grid-cols-5 max-w-7xl px-6 mx-auto'>
          <Logos productLogos={items} /></div>
          </div>
  )
}

export default ProductLogoShowcase
